import { render } from "./BaseCard.vue?vue&type=template&id=2e4efe2c"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=2e4efe2c&lang=css"

import exportComponent from "/Users/huangyuhao/Desktop/art-sleuth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__